// This file is generated.
export var version = '0.3.0';
//# sourceMappingURL=version.js.map